import { useRouter } from '@edreamsodigeo/frontend-core';
import { useMemo } from 'react';

const SHOPPING_BASKET_TOKEN_REGEX = new RegExp(/[^/]+\/([a-zA-Z0-9-_]{683})/);

export const useShoppingBasketTokenFromUrl = (): string => {
  const { query, pathname } = useRouter();
  const shoppingBasketTokenParam = query?.shoppingId as string;
  const [, shoppingBasketTokenFromPathname = null] =
    pathname?.match(SHOPPING_BASKET_TOKEN_REGEX) ?? [];
  return useMemo(
    () => shoppingBasketTokenParam ?? shoppingBasketTokenFromPathname ?? 0,
    [shoppingBasketTokenParam, shoppingBasketTokenFromPathname]
  );
};
